import styled from "styled-components";

// Now also used by the logged-out variant (LoggedOutHome), so these live in
// the shared Homepage/styledComponents — re-exported here since
// ActivityFeedHome/index.tsx already imports them from this local file.
export { CappedContent, HomepageContainer } from "../styledComponents";

export const FeedColumns = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 32px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FeedMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FeedAside = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 16px;
  width: 340px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;
